import React, { useRef, useState, useEffect } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import emailjs from '@emailjs/browser';
import swal from 'sweetalert';
import TopBanner from '../components/TopBanner';
import ReCAPTCHA from 'react-google-recaptcha';
import { ScrollToContent } from '../components/ScrollToContent';
import countryList from '../components/CountryData';

export const ContactUs = () => {
    const homeimg = '/images/home/home.jpg';
    const server_url = process.env.REACT_APP_SERVER;

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Lurantech",
        "url": `${server_url}`,
        "logo": `${server_url}/images/logo.png`,
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-7226-999-101",
            "contactType": "Customer Service",
            "areaServed": "IN, EU, AS",
            "availableLanguage": "English"
        },
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "FF-401, 4th Floor, 7 Sky Complex, Laxmipura, Near VUDA Cross Road",
            "addressLocality": "Vadodara",
            "addressRegion": "Gujarat",
            "postalCode": "390021",
            "addressCountry": "IN"
        },
        "description": "Get in touch with Lurantech! Our team of experts is ready to collaborate with you from consultation to full implementation. Let’s start your project today.",
        "sameAs": [
            "https://www.facebook.com/Lurantech-107968334690860",
            "https://www.linkedin.com/company/lurantech",
            "https://x.com/lurantech"
        ]
    }

    const form = useRef();
    const [selectedServices, setSelectedServices] = useState(['FreeConsultation']);
    // const [countries, setCountries] = useState(countryList); 
    const countries = countryList;
    const [captchaValue, setCaptchaValue] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState('');
    const dropdownRef = useRef(null)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    
    useEffect(() => {
        ScrollToContent('#contact-us-form')
    }, []);

    

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
          }
        };
    
        document.addEventListener("click", handleClickOutside);
    
        return () => {
          document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    
    
    const [selectedCountryCode, setSelectedCountryCode] = useState('+91'); // Default country code is +91 (India)

    const handleCountryCodeChange = (e) => {
        setSelectedCountryCode(e.target.value);
    };

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); 
        setPhoneNumber(value);
    };

    const handleServiceChange = (event) => {
        const value = event.target.value;
        if (event.target.checked) {
            setSelectedServices((prev) => [...prev, value]);
        } else {
            setSelectedServices((prev) => prev.filter((service) => service !== value));
        }
    };
    const handleCaptchaChange = (value) => {
        setCaptchaValue(value); 
    };

    const [loading, setLoading] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();

        if (!captchaValue) {
            swal("Error!", "Please verify that you are human.", "error");
            return;
        }

        setLoading(true);
        const servicesString = selectedServices.join(", ");
        form.current.querySelector('input[name="interested_services"]').value = servicesString;

        emailjs
            .sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, form.current, {
                publicKey: process.env.REACT_APP_PUBLIC_KEY
            })
            .then(
                () => {
                    setLoading(false);
                    console.log('SUCCESS!');
                    // alert("Your mail has been successfully sent!");
                    swal("Successfull!", "Email has been sent!", "success").then(() => window.location.reload());
                },
                (error) => {
                    setLoading(false);
                    console.log(error)
                    console.log('FAILED...', error.text);
                    swal("Oops!", "Can't send email now! Try again later!", "error").then(() => window.location.reload());
                },
            );
    };

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <meta property="og:title" content="Lurantech | Contact Us | Ready to Work Together" />
                    <meta property="og:description" content="Ready to work with us! Our experts is ready to collaborate with you at every step, from initial consultation to implementation. Let's chat, bring your ideas to life." />
                    <meta property="og:image" content={`${server_url}${homeimg}`} />
                    <meta property="og:url" content={`${server_url}/contact-us`} />
                    <meta property="og:type" content="website" />
                    <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="675" />
                    <meta name="geo.position" content="22.3026;73.1812" />
                    <meta name="geo.placename" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />
                    <meta name="geo.region" content="IN-GJ" />
                    <meta property="og:latitude" content="22.3026" />
                    <meta property="og:longitude" content="73.1812" />
                    <meta property="og:location" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />

                    
                    <meta name="twitter:title" content="Lurantech | Contact Us | Ready to Work Together" />
                    <meta name="twitter:description" content="Ready to work with us! Our experts is ready to collaborate with you at every step, from initial consultation to implementation. Let's chat, bring your ideas to life." />
                    <meta name="twitter:image" content={`${server_url}${homeimg}`} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:image:type" content="image/jpeg" />
                    <meta property="twitter:image:width" content="1200" />
                    <meta property="twitter:image:height" content="675" />

                    <meta name="robots" content="index, follow" />
                    <meta name="description" content="Ready to work with us! Our experts is ready to collaborate with you at every step, from initial consultation to implementation. Let's chat, bring your ideas to life." />
                    <meta name="keywords" content="contact us, contact lurantech, liferay consulting, it consultation, ready to work, consultation, implementation, IT experts, collaborate, start project" />
                    <meta name="author" content="Lurantech" />

                    <link rel="canonical" href={`${server_url}/contact-us`} />
                    <link rel="preload" href={`${server_url}${homeimg}`} as="image" />
                    <title>Lurantech | Contact Us | Ready to Work Together</title>
                </Helmet>

                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(schemaData),
                    }}
                />

                <TopBanner title="CONTACT US" />

                <div className='contact-us-top'>
                    <div className='row g-0'>
                        <div className="col-12 col-xs-3 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                            <div className='contact-sub-con'>
                                <img className='contact-sub-con-img' src="/images/contact-us/location-icon.svg" alt="lurantech-location" />
                                <div className='contact-card-title'>Location</div>
                                <div className='contact-card-info'>7 Sky, Laxmipura</div>
                                <div className='contact-card-info'>Vadodara, Gujarat 390021</div>
                            </div>
                        </div>
                        <div className="col-12 col-xs-3 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                            <div className='contact-sub-con'>
                                <img className='contact-sub-con-img' src="/images/contact-us/contact-icon.svg" alt="lurantech-contact" />
                                <div className='contact-card-title'>Contact</div>
                                <div className='contact-card-info'>+91 7226 999 101</div>
                                <div className='contact-card-info'>+91 9773 094 744</div>
                            </div>
                        </div>
                        <div className="col-12 col-xs-3 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                            <div className='contact-sub-con'>
                                <img className='contact-sub-con-img' src="/images/contact-us/upwork.svg" alt="lurantech-upwork" style={{'marginBottom':'-100px', 'height':'164px'}}/>
                                <div className='contact-card-title'>Upwork Profile</div>
                                <div className='contact-card-info'><a style={{'textDecoration': 'underline'}} href="https://www.upwork.com/agencies/lurantech/">Lurantech</a></div>
                            </div>
                        </div>
                        <div className="col-12 col-xs-3 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                            <div className='contact-sub-con'>
                                <img className='contact-sub-con-img' src="/images/contact-us/mail-icon.svg" alt="lurantech-email-address" />
                                <div className='contact-card-title'>Email</div>
                                <a style={{'textDecoration': 'underline'}} href="mailto:info@lurantech.com" className='contact-card-info'>info@lurantech.com</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='contact-us-bottom' id='contact-us-form'>
                    <div className='row g-0'>
                        <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                        <div className="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                            <div className='form-title'>
                                Send Us A Message
                            </div>
                            <div className='form-subtitle'>
                                Give us a chance to serve and bring magic to your brand.
                            </div>
                            <div className='c-form-container'>
                                <form ref={form} className="needs-validation" onSubmit={sendEmail}>
                                    <div className='row g-0'>
                                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                                            <div className='form-sub-con'>
                                                <div className='row g-0'>
                                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                        <div className='form-group-label'>
                                                            Full Name*
                                                        </div>
                                                        <input name='from_name' title="Please enter your name" className='form-input-text' type="text" required />
                                                    </div>
                                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                        <div className='form-group-label'>
                                                            Your Email*
                                                        </div>
                                                        <input name='from_email'  title="Please enter valid email address" className='form-input-text' type="email" required/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                       
                                                        <div className='form-group-label'>
                                                            <div className='form-group-label'>
                                                                Contact Number*
                                                            </div>
                                                            <div className="d-flex">
                                                                <select
                                                                    name="country_code"
                                                                    className="form-input-text country-codes"
                                                                    value={selectedCountryCode}
                                                                    onChange={handleCountryCodeChange}
                                                                    style={{ width: '60px' }}
                                                                >
                                                                    {countries.map((country, index) => (
                                                                        <option key={`code-${index}`} value={country.code || ''}>
                                                                            {`${country.code || ''} - (${country.name || ''})`}
                                                                        </option>                                                             
                                                                    ))}
                                                                </select>

                                                                <input
                                                                    title="Please enter valid phone number"
                                                                    name="from_number"
                                                                    className="form-input-text"
                                                                    type="text"
                                                                    value={phoneNumber}
                                                                    onChange={handlePhoneNumberChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
  
                                                    </div>
                                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                        <div className="form-group-label" style={{ marginBottom: '10px' }}>
                                                            Services you are looking for
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="dropdown" ref={dropdownRef}>
                                                            <button className="form-control dropdown-toggle" onClick={toggleDropdown} type="button" >
                                                                {selectedServices.length > 0 ? `${selectedServices.length} service selected` : 'Select Services'}
                                                            </button>
                                                            {dropdownOpen && (
                                                                <div className="dropdown-menu" style={{ maxHeight: '200px', overflowY: 'auto', display : 'inline-table' }}>
                                                                <div className="form-checkbox-group">
                                                                    <label><input type="checkbox" value="Liferay" checked={selectedServices.includes("FreeConsultation")} onChange={handleServiceChange} />Free Consultation</label>
                                                                    <label><input type="checkbox" value="Liferay" checked={selectedServices.includes("Liferay")} onChange={handleServiceChange} />Liferay CMS / E-Commerce</label>
                                                                    <label><input type="checkbox" value="AWS" checked={selectedServices.includes("AWS")} onChange={handleServiceChange} />Amazon Web Service</label>
                                                                    <label><input type="checkbox" value="ReactJS" checked={selectedServices.includes("ReactJS")} onChange={handleServiceChange} />React JS</label>
                                                                    <label><input type="checkbox" value="Java" checked={selectedServices.includes("Java")} onChange={handleServiceChange} />Java Technologies</label>
                                                                    <label><input type="checkbox" value="shopify" checked={selectedServices.includes("shopify")} onChange={handleServiceChange} />Shopify</label>
                                                                    <label><input type="checkbox" value="C++" checked={selectedServices.includes("C++")} onChange={handleServiceChange} />C++</label>
                                                                    <label><input type="checkbox" value="Rust" checked={selectedServices.includes("Rust")} onChange={handleServiceChange} />Rust</label>
                                                                    <label><input type="checkbox" value="Other" checked={selectedServices.includes("Other")} onChange={handleServiceChange} />Other</label>
                                                                </div>
                                                                </div>
                                                            )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                        <div className='form-group-label'>
                                                            Message*
                                                        </div>
                                                        <textarea name='message' title="Max character is allowed 2048" className='form-input-text' maxLength="2048" rows="8" required/>
                                                    </div>
                                                  
                                                    <input type="hidden" name="interested_services" />
                                                    <ReCAPTCHA
                                                        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                                        onChange={handleCaptchaChange}
                                                    />
                                                </div>
                                                <button className='form-submit-button' type="submit" value="send" disabled={loading}>
                                                    {loading ? 'Sending...' : 'SEND MESSAGE'}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                            <div className='map-iframe-con'>
                                              <a target="_blank" rel="noreferrer" href="https://maps.app.goo.gl/NsJRjRVcRe18XCnc9">
                                                <img className='iframe-style' src="/images/contact-us/luran-location.png" alt="lurantech-location"  style={{width:"100%"}}/>
                                              </a>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                    </div>
                </div>

            </HelmetProvider>
        </>
    );
};

export default ContactUs;
